<template >
  <div class="row panel-filter" v-if="searchFilters">
    <div class="col-sm-4">
      <div class="form-group-attached p-t-10">
          <label>Clients</label>
          <search-and-select :multiple="true"
            :initial-value="null"
            :search-config="cashingsCustomerSearchConfig"
            :get-option-label="getCustomerNameWithRepresentativeAndErpId"
            @field-updated="updateCustomer">
          </search-and-select>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group-attached p-t-10">
          <label>Type d'encaissement</label>
          <custom-select :field="fields[0]" :value="fields[0].value" :field_idx="0"
            @field-updated="updateMethod($event)" >
          </custom-select>
      </div>
      <div class="form-group-attached p-t-10" v-if="freeCashingType">
          <label>Organisation(s) créditée(s)</label>
          <custom-select :field="fields[1]" :value="fields[1].value" :field_idx="1"
            @field-updated="updateOrga" @input="performFiltering">
          </custom-select>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group-attached p-t-10">
          <label>Paiement effectué</label>
          <custom-select :field="fields[2]" :value="fields[2].value" :field_idx="2"
            @field-updated="updatePayable" @input="performFiltering">
          </custom-select>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .panel-filter { margin-bottom: 20px; }
</style>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import vSelect from 'vue-select'
import SearchAndSelect from "components/Forms/Elements/SearchAndSelect"
import CustomSelect from "components/Forms/Elements/Select"

import customerMixin from 'mixins/customer'
import searchMixin from 'mixins/search'

export default {

  name:"FilterBarCash",

  components:{
    SearchAndSelect,
    CustomSelect,
    vSelect
  },

  mixins: [customerMixin, searchMixin],

  data() {
    return {
      searchFilters: null,

      customerOptions: [],

      typeOptions: [
        {id: "free", name: "Encaissement libre"},
        {id: "invoices", name: "Règlement de facture(s)"}
      ],

      organizationOptions: [
        {id: 1, name: "SOFRADOM"},
        {id: 2, name: "SDM"},
        {id: 3, name: "ABC+"}
      ],

      payableOptions: [
        {id: 0, name: "Oui"},
        {id: 1, name: "Non"}
      ]
    }
  },

  methods: {
    ...mapActions('cash', ['updateFilters','customerCashings','agenciesWithOrganization','customersOfAgencies']),

    initialize() {
      this.searchFilters = {
        selected_organizations: [],
        selected_customers: [],
        selected_type: null,
        selected_search_date: null,
        selected_payable: null
      }
      this.updateFilters(this.searchFilters)
    },

    performFiltering(event) {
      this.updateFilters(this.searchFilters)
          .then(() => this.customerCashings())
    },

    onCashingTypeInput(event)
    {
      if ( !event || !event.value || event.value !== "free")
        this.searchFilters.selected_organizations = []
      this.performFiltering(true)
    },

    updateCustomer(event) {
      this.searchFilters.selected_customers = event
    },

    updateMethod(event)
    {
      this.searchFilters.selected_type = event.new_value
      this.onCashingTypeInput(event.new_value)
    },

    updateOrga(event)
    {
      this.searchFilters.selected_organizations = _.map(event.new_value, (v) => { return {id:String(v.value)}})
    },

    updatePayable(event)
    {
      this.searchFilters.selected_payable = event.new_value
    }

  },

  created() {
    this.initialize()
  },

  computed: {
    ...mapState(['agencies','user']),
    ...mapState('cash', ['customers','organizations','filters']),

    readyToRender() {
      if (this.searchFilters)
        return true

      return false
    },

    freeCashingType() {
      return this.searchFilters.selected_type && this.searchFilters.selected_type.value === 'free'
    },

    fields() {
      let v = [
        {values:this.typeOptions, multiple:false, placeholder:"", disabled:this.is_fetching, idx:1, required:true, value:null , label:"",type:"select"},
        {values:this.organizationOptions, multiple:true, placeholder:"", disabled:this.is_fetching, idx:2, required:true, value:this.searchFilters.selected_organization , label:"",type:"select"},
        {values:this.payableOptions, multiple:false, placeholder:"", disabled:this.is_fetching, idx:3, required:true, value:this.searchFilters.selected_payable , label:"",type:"select"},
      ]
      return v
    }
  },

  watch : {
    searchFilters :
      {
        handler : function () {
          this.performFiltering(true)
        },
        deep : true
      },
  }
}
</script>



// WEBPACK FOOTER //
// client/components/Cash/FilterBarCash.vue